import React from 'react';

const LimitAndWeekendSettings = ({
  limit = 100,
  onLimitChange,
  noWeekend = false,
  onNoWeekendChange
}) => {
  const handleLimitChange = (e) => {
    const value = e.target.value;
    const numValue = value === '' ? 0 : parseInt(value);
    onLimitChange(isNaN(numValue) ? 0 : numValue);
  };

  const handleNoWeekendChange = () => {
    onNoWeekendChange(!noWeekend);
  };

  return (
    <div className="package-settings-section">
      <div className="daily-limit d-flex align-items-center gap-2 mt-2">
        <span>Мне нужно отправлять</span>
        <input 
          type="number"
          value={limit > 0 ? limit : ''} 
          placeholder="0"
          onChange={handleLimitChange}
          className="limit-input"
        />
        <span>идентификаций в сутки</span>
      </div>
      <div className="weekend-option d-flex align-items-center gap-2 mt-2">
        <input 
          type="checkbox" 
          checked={noWeekend} 
          onChange={handleNoWeekendChange}
        />
        <span>Не отправлять трафик в выходные дни</span>
      </div>
    </div>
  );
};

export default LimitAndWeekendSettings;
